import {
  GAP_CHIP_OPPOSITION,
  GAP_CHIP_STAKES,
  GAP_CHIP_WANT,
} from './writerCopy';

export const GAP_CHIP_CAP = 3;

const SCENE_KINDS = new Set(['purpose', 'name', 'order']);
const PRESSURE_KINDS = new Set(['want', 'opposition', 'stakes']);

export function chipLabel(chip) {
  const name = String(chip?.scene_name || '').trim();
  if (chip?.kind === 'purpose') {
    return name ? `${name} still needs what it does` : 'A scene still needs what it does';
  }
  if (chip?.kind === 'name') {
    return name ? `${name} needs a clearer name` : 'A scene needs a clearer name';
  }
  if (chip?.kind === 'order') {
    return name ? `Order looks off for ${name}` : 'Order looks off';
  }
  if (chip?.kind === 'want') return GAP_CHIP_WANT;
  if (chip?.kind === 'opposition') return GAP_CHIP_OPPOSITION;
  if (chip?.kind === 'stakes') return GAP_CHIP_STAKES;
  return '';
}

export function scenePurposeBlocksDraft(gaps, sceneId) {
  if (!gaps || gaps.path_kind !== 'A' || !sceneId) return false;
  const row = (gaps.scenes || []).find((scene) => String(scene.id) === String(sceneId));
  if (!row) return false;
  return row.purpose_settled === false;
}

export function importedSceneFor(gaps, sceneId) {
  if (!gaps || !sceneId) return null;
  return (gaps.scenes || []).find((scene) => String(scene.id) === String(sceneId)) || null;
}

/**
 * Landing room only. Plot Grid shows Path A. Framework and Plot Focus show Path B.
 * Scene chips cap at 3. Book pressure on Plot Grid is the strip, not the cap.
 */
export function presentGaps(gaps, room, { expanded = false, cap = GAP_CHIP_CAP, povSlot = false } = {}) {
  if (!gaps || (gaps.path_kind !== 'A' && gaps.path_kind !== 'B')) return null;
  if (room === 'plot' && gaps.path_kind !== 'A') return null;
  if (room !== 'plot' && gaps.path_kind !== 'B') return null;
  const chips = Array.isArray(gaps.chips) ? gaps.chips : [];
  const sceneChips = chips.filter((chip) => SCENE_KINDS.has(chip.kind));
  const pressure = chips.filter((chip) => PRESSURE_KINDS.has(chip.kind));
  const capped = room === 'plot' ? sceneChips : pressure;
  const budget = povSlot ? Math.max(0, cap - 1) : cap;
  const hidden = expanded ? 0 : Math.max(0, capped.length - budget);
  const shown = expanded ? capped : capped.slice(0, budget);
  const banner = gaps.banner === 'purpose' || gaps.banner === 'pressure' ? gaps.banner : null;
  if (room === 'plot') {
    if (!banner && sceneChips.length === 0 && pressure.length === 0) return null;
    return {
      banner,
      sceneChips: shown,
      pressure,
      hidden,
      focusSceneId: gaps.focus_scene_id || null,
    };
  }
  if (pressure.length === 0) return null;
  return {
    banner: 'pressure',
    sceneChips: [],
    pressure: shown,
    hidden,
    focusSceneId: null,
  };
}
